// import { useState, useEffect } from "react"
// import SalesForm from "./SalesForm"
// import { auth, database } from "../firebase"
// import { ref, onValue, remove, get, update } from "firebase/database"

// const SalesTable = () => {
//   const [showForm, setShowForm] = useState(false)
//   const [salesData, setSalesData] = useState([])
//   const [currentUser, setCurrentUser] = useState(null)
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState(null)
//   const [saleToEdit, setSaleToEdit] = useState(null)
//   const [showBillView, setShowBillView] = useState(false)
//   const [selectedSale, setSelectedSale] = useState(null)
//   const [branchProfile, setBranchProfile] = useState(null)
//   const [currentUserName, setCurrentUserName] = useState('')

//   const encodeEmailForPath = (email) => {
//     return email.replace(/[.#$[\]]/g, "_")
//   }

//   const formatNumber = (value) => {
//     const num = Number.parseFloat(value)
//     return isNaN(num) ? (0).toFixed(2) : num.toFixed(2)
//   }

//   const formatDate = (dateStr) => {
//     if (!dateStr) return ""
//     const parts = dateStr.split("-")
//     if (parts.length === 3) {
//       return `${parts[0]}-${parts[1]}-${parts[2]}`
//     }
//     return dateStr
//   }

//   const formatDateTimeForReceipt = (dateStr) => {
//     if (!dateStr) return { date: "", time: "" }
//     const now = new Date()
//     const date = formatDate(dateStr)
//     const time = now.toLocaleTimeString("en-IN", {
//       hour12: true,
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//     })
//     return { date, time }
//   }

//   // Function to get HSN/SAC code from products database
//   const getProductHsnCode = async (productName) => {
//     if (!currentUser || !productName) return "N/A";
    
//     try {
//       const encodedEmail = encodeEmailForPath(currentUser.email);
//       const productsRef = ref(database, `users/${encodedEmail}/products`);
//       const snapshot = await get(productsRef);
      
//       if (snapshot.exists()) {
//         const products = snapshot.val();
//         const product = Object.values(products).find(p => p.productName === productName);
//         return product?.hsnSacCode || "N/A";
//       }
//       return "N/A";
//     } catch (error) {
//       console.error("Error fetching HSN code:", error);
//       return "N/A";
//     }
//   };

//   // Fetch current user
//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged((user) => {
//       setCurrentUser(user)
//       setLoading(false)
//     })
//     return () => unsubscribe()
//   }, [])

//   // Fetch current user's name from employee data or profile
//   useEffect(() => {
//     if (!currentUser) {
//       setCurrentUserName('')
//       return
//     }

//     const encodedEmail = encodeEmailForPath(currentUser.email)

//     // First, check if user has a profile (for employees)
//     const userProfileRef = ref(database, `users/${encodedEmail}/profile`)
//     const unsubscribeProfile = onValue(userProfileRef, (snapshot) => {
//       const profileData = snapshot.val()
//       if (profileData && profileData.personalInfo && profileData.personalInfo.name) {
//         setCurrentUserName(profileData.personalInfo.name)
//         return
//       }

//       // If no profile found or no name in profile, check if user is in someone's employee list
//       const checkAsEmployee = async () => {
//         try {
//           // Get all users and check their employee lists
//           const usersRef = ref(database, 'users')
//           const usersSnapshot = await get(usersRef)
          
//           if (usersSnapshot.exists()) {
//             const users = usersSnapshot.val()
//             let foundEmployeeName = null

//             // Iterate through all users to find if current user is an employee
//             for (const [userKey, userData] of Object.entries(users)) {
//               if (userData.employees) {
//                 // Check if current user email exists in this user's employees
//                 for (const [employeeId, employeeData] of Object.entries(userData.employees)) {
//                   if (employeeData.email === currentUser.email) {
//                     foundEmployeeName = employeeData.name
//                     break
//                   }
//                 }
//                 if (foundEmployeeName) break
//               }
//             }

//             if (foundEmployeeName) {
//               setCurrentUserName(foundEmployeeName)
//             } else {
//               // If not found as employee, use email prefix as default
//               const defaultName = currentUser.email.split('@')[0].toUpperCase()
//               setCurrentUserName(defaultName)
//             }
//           }
//         } catch (error) {
//           console.error('Error checking employee data:', error)
//           // Fallback to email prefix
//           const defaultName = currentUser.email.split('@')[0].toUpperCase()
//           setCurrentUserName(defaultName)
//         }
//       }

//       checkAsEmployee()
//     }, (error) => {
//       console.error('Error fetching user profile:', error)
//       // Fallback to email prefix
//       if (currentUser) {
//         const defaultName = currentUser.email.split('@')[0].toUpperCase()
//         setCurrentUserName(defaultName)
//       }
//     })

//     return () => unsubscribeProfile()
//   }, [currentUser])

//   // Fetch branch profile data
//   useEffect(() => {
//     if (!currentUser) {
//       setBranchProfile(null)
//       return
//     }

//     const encodedEmail = encodeEmailForPath(currentUser.email)
//     const branchProfilesRef = ref(database, `users/${encodedEmail}/branchProfiles`)
//     const unsubscribe = onValue(branchProfilesRef, (snapshot) => {
//       try {
//         const data = snapshot.val()
//         if (data) {
//           const profiles = Object.entries(data)
//           const latestProfile = profiles[profiles.length - 1]
//           setBranchProfile(latestProfile[1])
//         } else {
//           setBranchProfile(null)
//         }
//       } catch (err) {
//         console.error("Error fetching branch profile:", err)
//         setBranchProfile(null)
//       }
//     })

//     return () => unsubscribe()
//   }, [currentUser])

//   // Fetch sales data from Firebase
//   useEffect(() => {
//     if (!currentUser) {
//       setSalesData([])
//       setLoading(false)
//       return
//     }

//     setLoading(true)
//     const encodedEmail = encodeEmailForPath(currentUser.email)
//     const salesRef = ref(database, `users/${encodedEmail}/sales`)

//     const unsubscribe = onValue(
//       salesRef,
//       (snapshot) => {
//         try {
//           const data = snapshot.val()
//           if (data) {
//             const salesList = Object.keys(data)
//               .map((key) => ({
//                 id: key,
//                 ...data[key],
//                 totals: {
//                   grossAmt: Number.parseFloat(data[key].totals?.grossAmt) || 0,
//                   discount: Number.parseFloat(data[key].totals?.discount) || 0,
//                   billDiscount: Number.parseFloat(data[key].totals?.billDiscount) || 0,
//                   totalTax: Number.parseFloat(data[key].totals?.totalTax) || 0,
//                   netAmount: Number.parseFloat(data[key].totals?.netAmount) || 0,
//                 },
//               }))
//               .filter((sale) => sale.billNo && sale.date)
//             setSalesData(salesList)
//             setError(null)
//           } else {
//             setSalesData([])
//             setError(null)
//           }
//           setLoading(false)
//         } catch (err) {
//           console.error("Error processing sales data:", err)
//           setError("Failed to load sales data.")
//           setSalesData([])
//           setLoading(false)
//         }
//       },
//       (error) => {
//         console.error("Firebase error:", error)
//         setError("Failed to fetch sales data.")
//         setSalesData([])
//         setLoading(false)
//       },
//     )

//     return () => unsubscribe()
//   }, [currentUser])

//   // Restore product stock when a sale is deleted
//   const restoreProductStock = async (saleData, encodedEmail) => {
//     try {
//       const productsRef = ref(database, `users/${encodedEmail}/products`)
//       const snapshot = await get(productsRef)
//       const products = snapshot.exists()
//         ? Object.keys(snapshot.val()).map((key) => ({
//             id: key,
//             ...snapshot.val()[key],
//           }))
//         : []

//       for (const item of saleData.items) {
//         const product = products.find((p) => p.productName === item.itemDescription)
//         if (product && item.qty) {
//           const qtySold = Number.parseFloat(item.qty) || 0
//           const currentStock = Number.parseFloat(product.openingStock) || 0
//           const restoredStock = currentStock + qtySold

//           const productRef = ref(database, `users/${encodedEmail}/products/${product.id}`)
//           await update(productRef, { openingStock: restoredStock.toString() })
//           console.log(`Restored stock for ${product.productName}: ${restoredStock}`)
//         }
//       }
//     } catch (error) {
//       console.error("Error restoring product stock:", error)
//       throw new Error("Failed to restore product stock")
//     }
//   }

//   const handleFormSubmit = () => {
//     setShowForm(false)
//     setSaleToEdit(null)
//   }

//   const handleEdit = (sale) => {
//     setSaleToEdit(sale)
//     setShowForm(true)
//   }

// const handleDelete = async (saleId) => {
//   if (!window.confirm("Are you sure you want to delete this sale?")) return

//   if (!currentUser) {
//     setError("No user is logged in.")
//     return
//   }

//   const encodedEmail = encodeEmailForPath(currentUser.email)
//   const saleRef = ref(database, `users/${encodedEmail}/sales/${saleId}`)

//   try {
//     const snapshot = await get(saleRef)
//     if (!snapshot.exists()) {
//       setError("Sale not found.")
//       return
//     }

//     const saleData = snapshot.val()
//     await restoreProductStock(saleData, encodedEmail)
//     await remove(saleRef)
//     setError(null)
//     setSalesData((prev) => prev.filter((sale) => sale.id !== saleId))
//     alert('Sale deleted successfully!') // Display alert after successful deletion
//   } catch (error) {
//     console.error("Error deleting sale:", error)
//     setError(`Failed to delete sale: ${error.message}`)
//     alert(`Error: ${error.message}`) // Display alert for error
//   }
// }

// const handleView = async (sale) => {
//   // Get HSN codes for all items
//   const itemsWithHsn = await Promise.all(
//     sale.items.map(async (item) => {
//       const hsnCode = await getProductHsnCode(item.itemDescription);
//       return { ...item, hsnSacCode: hsnCode };
//     })
//   );

//   const billContent = `
//     <!DOCTYPE html>
//     <html>
//     <head>
//       <style>
//         body {
//           font-family: Arial, sans-serif;
//           font-size: 10px; /* Reduced base font size */
//           line-height: 1.3; /* Tighter line height */
//           color: #000;
//           background-color: white;
//           margin: 0;
//           padding: 10px; /* Reduced padding */
//         }
//         .invoice {
//           max-width: 800px;
//           margin: 0 auto;
//           border: 1px solid #3b82f6; /* Thinner border */
//           border-radius: 8px;
//           padding: 15px; /* Reduced padding */
//           background-color: white;
//           box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//           font-family: Arial, sans-serif;
//           font-size: 10px; /* Smaller font size */
//           page-break-inside: avoid; /* Prevent page breaks inside invoice */
//         }
//         .invoice-header {
//           text-align: center;
//           margin-bottom: 15px; /* Reduced margin */
//           padding-bottom: 10px; /* Reduced padding */
//           border-bottom: 1px solid #e2e8f0; /* Thinner border */
//         }
//         .company-name {
//           font-size: 18px; /* Reduced font size */
//           font-weight: bold;
//           margin: 0;
//           margin-bottom: 3px; /* Reduced margin */
//           color: #1e293b;
//           text-shadow: 1px 1px 1px rgba(0,0,0,0.1);
//         }
//         .company-details {
//           font-size: 10px; /* Smaller font size */
//           color: #475569;
//           margin: 3px 0; /* Reduced margin */
//         }
//         .tax-invoice {
//           font-size: 12px; /* Reduced font size */
//           font-weight: 600;
//           color: #3b82f6;
//           margin-top: 5px; /* Reduced margin */
//         }
//         .invoice-info {
//           display: flex;
//           justify-content: space-between;
//           margin: 10px 0; /* Reduced margin */
//           padding: 10px; /* Reduced padding */
//           background-color: #f8fafc;
//           border-radius: 6px;
//           border: 1px solid #e2e8f0;
//         }
//         .invoice-info-left, .invoice-info-right {
//           width: 48%;
//           font-size: 10px; /* Smaller font size */
//         }
//         .invoice-info-right {
//           text-align: right;
//         }
//         .customer-section {
//           margin-bottom: 10px; /* Reduced margin */
//           font-size: 10px; /* Smaller font size */
//         }
//         .items-table {
//           width: 100%;
//           border-collapse: collapse;
//           margin-bottom: 15px; /* Reduced margin */
//           border: 1px solid #3b82f6; /* Thinner border */
//           border-radius: 6px;
//           overflow: hidden;
//           box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
//           page-break-inside: avoid; /* Prevent table from breaking */
//         }
//         .items-table th {
//           border: 1px solid #cbd5e1;
//           padding: 6px 4px; /* Reduced padding */
//           background-color: #f1f5f9;
//           font-weight: 600;
//           text-align: center;
//           font-size: 9px; /* Smaller font size */
//           color: #1e293b;
//           text-transform: uppercase;
//           letter-spacing: 0.3px;
//         }
//         .items-table td {
//           border: 1px solid #cbd5e1;
//           padding: 5px 4px; /* Reduced padding */
//           vertical-align: middle;
//           font-size: 9px; /* Smaller font size */
//           line-height: 1.1; /* Tighter line height */
//         }
//         .items-table td.left {
//           text-align: left;
//         }
//         .items-table td.right {
//           text-align: right;
//         }
//         .items-table td.center {
//           text-align: center;
//         }
//         .items-table tbody tr:nth-child(even) {
//           background-color: #f8fafc;
//         }
//         .items-table tbody tr:hover {
//           background-color: #f1f5f9;
//         }
//         .total-section {
//           display: flex;
//           justify-content: space-between;
//           margin-bottom: 15px; /* Reduced margin */
//           gap: 10px; /* Reduced gap */
//         }
//         .bank-details {
//           width: 48%;
//           font-size: 9px; /* Smaller font size */
//           padding: 10px; /* Reduced padding */
//           background-color: #f8fafc;
//           border-radius: 6px;
//           border: 1px solid #e2e8f0;
//         }
//         .total-box {
//           width: 48%;
//           font-size: 10px; /* Smaller font size */
//           padding: 10px; /* Reduced padding */
//           background-color: #f8fafc;
//           border-radius: 6px;
//           border: 1px solid #e2e8f0;
//         }
//         .total-row {
//           display: flex;
//           justify-content: space-between;
//           margin-bottom: 4px; /* Reduced margin */
//           padding: 3px 0; /* Reduced padding */
//         }
//         .net-total-row {
//           display: flex;
//           justify-content: space-between;
//           font-weight: bold;
//           border-top: 1px solid #3b82f6; /* Thinner border */
//           padding-top: 5px; /* Reduced padding */
//           margin-top: 5px; /* Reduced margin */
//           font-size: 11px; /* Smaller font size */
//           color: #1e293b;
//         }
//         .terms-section {
//           font-size: 9px; /* Smaller font size */
//           margin-bottom: 15px; /* Reduced margin */
//           line-height: 1.2; /* Tighter line height */
//           padding: 10px; /* Reduced padding */
//           background-color: #f8fafc;
//           border-radius: 6px;
//           border: 1px solid #e2e8f0;
//         }
//         .signature-section {
//           text-align: right;
//           font-size: 10px; /* Smaller font size */
//           margin-top: 20px; /* Reduced margin */
//           padding: 10px; /* Reduced padding */
//         }
//         .footer {
//           text-align: center;
//           font-size: 8px; /* Smaller font size */
//           margin-top: 15px; /* Reduced margin */
//           color: #64748b;
//           font-style: italic;
//           border-top: 1px solid #e2e8f0;
//           padding-top: 10px; /* Reduced padding */
//         }
//         @media print {
//           body {
//             margin: 0;
//             padding: 0;
//           }
//           .invoice {
//             border: none;
//             box-shadow: none;
//             padding: 5px; /* Minimal padding for print */
//             margin: 0;
//             max-width: none;
//             font-size: 9px; /* Ensure smaller font for print */
//             transform: scale(0.95); /* Slightly scale down to fit */
//             transform-origin: top;
//             page-break-inside: avoid; /* Prevent page breaks */
//           }
//           .items-table {
//             page-break-inside: avoid; /* Prevent table breaking */
//           }
//           .total-section, .terms-section, .signature-section, .footer {
//             page-break-inside: avoid; /* Prevent breaking */
//           }
//           @page {
//             margin: 0.5cm; /* Reduced page margins */
//           }
//         }
//       </style>
//     </head>
//     <body>
//       <div class="invoice">
//         <div class="invoice-header">
//           <div class="company-name">${branchProfile?.branchName || "SUPREME TRADERS"}</div>
//           <div class="company-details">
//             ${branchProfile?.address1 && `${branchProfile.address1}`}
//             ${branchProfile?.address2 && `, ${branchProfile.address2}`}<br/>
//             ${branchProfile?.city || "SALEM"} - ${branchProfile?.zipCode || "123456"}<br/>
//             Ph: ${branchProfile?.phoneNo || "7708970307"}<br/>
//             GSTIN: ${branchProfile?.gstinNo || "33AVSPV4056G1Z4"}
//           </div>
//           <div class="tax-invoice">TAX INVOICE</div>
//         </div>
        
//         <div class="invoice-info">
//           <div class="invoice-info-left">
//             <strong>TO:</strong><br/>
//             <strong>${sale.customer || "WALK-IN CUSTOMER"}</strong><br/>
//             <strong>Phone:</strong> ${sale.phone || "N/A"}
//           </div>
//           <div class="invoice-info-right">
//             <strong>Date:</strong> ${formatDate(sale.date)}<br/>
//             <strong>Bill No:</strong> ${sale.billNo}<br/>
//             <strong>Bill Type:</strong> ${sale.terms || "CASH"}<br/>
//             <strong>Sales Person:</strong> ${sale.salesMan || currentUserName || "N/A"}
//           </div>
//         </div>

//         <table class="items-table">
//           <thead>
//             <tr>
//               <th>S.No</th>
//               <th>Item Description</th>
//               <th>HSN/SAC</th>
//               <th>Quantity</th>
//               <th>Rate</th>
//               <th>GST</th>
//               <th>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             ${
//               itemsWithHsn &&
//               itemsWithHsn
//                 .map(
//                   (item, index) => `
//                 <tr>
//                   <td class="center">${index + 1}</td>
//                   <td class="left">${item.itemDescription || "N/A"}</td>
//                   <td class="center">${item.hsnSacCode || "N/A"}</td>
//                   <td class="right">${item.qty || "0"}</td>
//                   <td class="right">₹${formatNumber(item.unitRate || 0)}</td>
//                   <td class="center">${item.tax || "0"}%</td>
//                   <td class="right">₹${formatNumber(item.netValue || 0)}</td>
//                 </tr>
//               `,
//                 )
//                 .join("")
//             }
//             <tr style="background-color: #fef3c7; font-weight: bold; border-top: 1px solid #f59e0b;">
//               <td colspan="4" class="right" style="font-weight: bold;">
//               Total Qty: ${sale.items ? sale.items.reduce((sum, item) => sum + (Number.parseFloat(item.qty) || 0), 0) : 0} Items
//               </td>
//               <td class="right" style="font-weight: bold;">Gross Amount:</td>
//               <td colspan="2" class="right" style="font-weight: bold;">₹${formatNumber(sale.totals.grossAmt)}</td>
//             </tr>
//           </tbody>
//         </table>

//         <div class="total-section">
//           <div class="bank-details">
//             <strong>Company's Bank Details:</strong><br/><br/>
//             <strong>Bank Name:</strong> ${branchProfile?.bankName || "SHRISWAPAY"}<br/>
//             <strong>A/C No:</strong> ${branchProfile?.accountNo || "614405018162"}<br/>
//             <strong>Branch Name:</strong> ${branchProfile?.bankBranchName || "NETHIMEDU"}<br/>
//             <strong>IFSC Code:</strong> ${branchProfile?.ifscCode || "ICIC0006144"}<br/>
//             <strong>MICR Code:</strong> ${branchProfile?.micrCode || "MICR CODE"}<br/>
//             <br/>
//             <strong>Declarations:</strong><br/>
//             • Goods once sold will not be taken back or exchanged<br/>
//             • E&OE<br/>
//             • Subject to ${branchProfile?.city?.toUpperCase() || "SALEM"} jurisdiction
//           </div>
          
//           <div class="total-box">
//             <div class="total-row">
//               <span>CGST:</span>
//               <span>₹${formatNumber(sale.totals.totalTax / 2)}</span>
//             </div>
//             <div class="total-row">
//               <span>SGST:</span>
//               <span>₹${formatNumber(sale.totals.totalTax / 2)}</span>
//             </div>
//             <div class="total-row">
//               <span>Discount:</span>
//               <span>₹${formatNumber(sale.totals.discount)}</span>
//             </div>
//             <div class="total-row">
//               <span>Bill Discount:</span>
//               <span>₹${formatNumber(sale.totals.billDiscount)}</span>
//             </div>
//             <div class="total-row">
//               <span>Rounded Off:</span>
//               <span>₹0.00</span>
//             </div>
//             <div class="net-total-row">
//               <span>NET TOTAL:</span>
//               <span>₹${formatNumber(sale.totals.netAmount)}</span>
//             </div>
//           </div>
//         </div>

//         <div class="terms-section">
//           <strong>Terms & Conditions:</strong><br/>
//           1. Goods once sold will not be taken back or exchanged.<br/>
//           2. All disputes are subject to local jurisdiction.<br/>
//           3. Payment terms: ${sale.terms || "CASH"}<br/>
//           ${sale.remarks ? `4. <strong>Remarks:</strong> ${sale.remarks}<br/>` : ''}
//           ${sale.otherDetails ? `5. <strong>Other Details:</strong> ${sale.otherDetails}<br/>` : ''}
//         </div>

//         <div class="signature-section">
//           <strong>For ${branchProfile?.branchName || "SUPREME TRADERS"}</strong><br/>
//           <br/>
//           <br/>
//           <strong>Authorized Signatory</strong>
//         </div>

//         <div class="footer">
//           This is a computer generated invoice
//         </div>
//       </div>
      
//       <script>
//         window.onload = function() {
//           window.print();
//         }
//       </script>
//     </body>
//     </html>
//   `

//   const newTab = window.open("", "_blank")
//   if (newTab) {
//     newTab.document.write(billContent)
//     newTab.document.close()
//   }
// }


// // Updated downloadPDF function - Wider QTY column + Total Qty label positioned clearly
// const downloadPDF = async (sale) => {
//   const { date, time } = formatDateTimeForReceipt(sale.date);

//   // Total Qty (sum of all product qty)
//   const totalQty = sale.items ? sale.items.reduce((sum, item) => sum + (Number.parseInt(item.qty) || 0), 0) : 0;

//   // Total Items (number of distinct products)
//   const totalItems = sale.items ? sale.items.length : 0;

//   const cgstAmount = formatNumber(sale.totals.totalTax / 2);
//   const sgstAmount = formatNumber(sale.totals.totalTax / 2);

//   // Get HSN codes for all items
//   const itemsWithHsn = await Promise.all(
//     sale.items.map(async (item) => {
//       const hsnCode = await getProductHsnCode(item.itemDescription);
//       return { ...item, hsnSacCode: hsnCode };
//     })
//   );

//   const compactReceiptContent = `
//     <!DOCTYPE html>
//     <html>
//     <head>
//       <style>
//         body {
//           font-family: Arial, sans-serif;
//           font-size: 14px;
//           line-height: 1.4;
//           color: #000;
//           background-color: white;
//           margin: 0;
//           padding: 20px;
//         }
//         .receipt {
//           max-width: 520px;
//           margin: 0 auto;
//           border: 2px solid #3b82f6;
//           border-radius: 12px;
//           padding: 30px;
//           background-color: white;
//           box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
//           font-family: Arial, sans-serif;
//           page-break-inside: avoid;
//         }
//         .header {
//           text-align: center;
//           margin-bottom: 30px;
//           padding-bottom: 20px;
//           border-bottom: 2px solid #e2e8f0;
//         }
//         .company-name {
//           font-size: 24px;
//           font-weight: bold;
//           margin: 10px 0;
//           color: #1e293b;
//           text-shadow: 1px 1px 2px rgba(0,0,0,0.1);
//         }
//         .company-details {
//           font-size: 14px;
//           margin: 5px 0;
//           color: #475569;
//         }
//         .invoice-info {
//           display: flex;
//           justify-content: space-between;
//           margin: 20px 0;
//           font-size: 14px;
//           font-weight: 600;
//           padding: 15px;
//           background-color: #f8fafc;
//           border-radius: 8px;
//           border: 1px solid #e2e8f0;
//         }
//         .items-section {
//           margin: 30px 0;
//         }
//         .items-header {
//           display: flex;
//           justify-content: space-between;
//           font-weight: bold;
//           background-color: #f1f5f9;
//           padding: 12px 15px;
//           font-size: 14px;
//           border: 1px solid #cbd5e1;
//           border-radius: 8px 8px 0 0;
//           color: #1e293b;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }
//         .item-row {
//           display: flex;
//           justify-content: space-between;
//           padding: 12px 15px;
//           font-size: 13px;
//           border: 1px solid #cbd5e1;
//           border-top: none;
//           background-color: white;
//         }
//         .item-row:nth-child(even) {
//           background-color: #f8fafc;
//         }
//         .item-row:hover {
//           background-color: #f1f5f9;
//         }
//         .item-name {
//           flex: 2;
//           text-align: left;
//           font-weight: 500;
//         }
//         .item-details {
//           display: flex;
//           flex: 3;
//           justify-content: space-between;
//           text-align: right;
//         }
        
//         /* Updated column widths - Make QTY column much wider */
//         .item-details span:nth-child(1) { /* MRP */
//           min-width: 70px;
//           flex: 1;
//         }
//         .item-details span:nth-child(2) { /* RATE */
//           min-width: 70px;
//           flex: 1;
//         }
//         .item-details span:nth-child(3) { /* QTY - Much wider now */
//           min-width: 120px;
//           flex: 1.5;
//           text-align: center;
//           font-weight: bold;
//         }
//         .item-details span:nth-child(4) { /* AMOUNT */
//           min-width: 80px;
//           flex: 1.2;
//         }
        
//         .totals-section {
//           margin-top: 30px;
//           padding: 20px;
//           background-color: #f8fafc;
//           border-radius: 8px;
//           border: 1px solid #e2e8f0;
//         }
//         .total-row {
//           display: flex;
//           justify-content: space-between;
//           margin: 10px 0;
//           font-size: 14px;
//           padding: 5px 0;
//         }
//         .net-total {
//           font-weight: bold;
//           border-top: 2px solid #3b82f6;
//           padding-top: 15px;
//           margin-top: 15px;
//           font-size: 16px;
//           color: #1e293b;
//         }
//         .savings-row {
//           display: flex;
//           justify-content: space-between;
//           font-weight: bold;
//           margin: 25px 0;
//           font-size: 16px;
//           padding: 15px;
//           background-color: #ecfdf5;
//           border-radius: 8px;
//           border: 1px solid #10b981;
//           color: #047857;
//         }
        
//         /* Special styling for summary row to align Total Qty under QTY column */
//         .summary-row {
//           font-weight: bold;
//           background-color: #fef3c7 !important;
//           border-top: 2px solid #f59e0b !important;
//         }
        
//         .summary-row .item-name {
//           font-size: 14px;
//         }
        
//         .summary-row .item-details span:nth-child(3) {
//           color: #b45309;
//           font-size: 14px;
//           font-weight: bold;
//         }
        
//         .footer {
//           text-align: center;
//           font-weight: bold;
//           margin-top: 30px;
//           font-size: 16px;
//           color: #3b82f6;
//           border-top: 2px solid #e2e8f0;
//           padding-top: 20px;
//         }
//         @media print {
//           .receipt {
//             border: none;
//             box-shadow: none;
//             padding: 10px;
//             margin: 0;
//             max-width: none;
//           }
//           body {
//             margin: 0;
//             padding: 0;
//           }
//         }
//       </style>
//     </head>
//     <body>
//       <div class="receipt">
//         <div class="header">
//           <div class="company-name">${branchProfile?.branchName || "SuperMarket"}</div>
//           <div class="company-details">City: ${branchProfile?.city || "Salem"}</div>
//           <div class="company-details">ZIP Code: ${branchProfile?.zipCode || "414001"}</div>
//           <div class="company-details">Call: ${branchProfile?.phoneNo || "7708970307"}</div>
//           <div class="company-details">GSTIN: ${branchProfile?.gstinNo || "33AVSPV4056G1Z4"}</div>
//         </div>
        
//         <div class="invoice-info">
//           <span>Invoice No: ${sale.billNo}</span>
//           <span>Date: ${date}</span>
//         </div>
        
//         <div class="items-section">
//           <div class="items-header">
//             <span class="item-name">ITEMS</span>
//             <div class="item-details">
//               <span>MRP</span>
//               <span>RATE</span>
//               <span>QTY</span>
//               <span>AMOUNT</span>
//             </div>
//           </div>
          
//           ${itemsWithHsn && itemsWithHsn.map((item) => `
//             <div class="item-row">
//               <span class="item-name">${(item.itemDescription || "N/A").toUpperCase()}</span>
//               <div class="item-details">
//                 <span>₹${formatNumber(item.unitRate || 0)}</span>
//                 <span>₹${formatNumber(item.unitRate || 0)}</span>
//                 <span>${item.qty || "0"}</span>
//                 <span>₹${formatNumber(item.netValue || 0)}</span>
//               </div>
//             </div>
//           `).join('')}
          
//           <!-- Summary row with proper alignment -->
//           <div class="item-row summary-row">
//             <span class="item-name">🛒 Total Items: ${totalItems}</span>
//             <div class="item-details">
//               <span></span>
//               <span></span>
//               <span>Total Qty: ${totalQty}</span>
//               <span>₹${formatNumber(sale.totals.grossAmt)}</span>
//             </div>
//           </div>
//         </div>
        
//         <div class="totals-section">
//           <div class="total-row">
//             <span>CGST Tax:</span>
//             <span>₹${cgstAmount}</span>
//           </div>
//           <div class="total-row">
//             <span>SGST Tax:</span>
//             <span>₹${sgstAmount}</span>
//           </div>
//           <div class="total-row">
//             <span>Discount:</span>
//             <span>₹${formatNumber(sale.totals.discount)}</span>
//           </div>
//           <div class="total-row">
//             <span>Bill Discount:</span>
//             <span>₹${formatNumber(sale.totals.billDiscount)}</span>
//           </div>
//           <div class="total-row net-total">
//             <span>NET TOTAL:</span>
//             <span>₹${formatNumber(sale.totals.netAmount)}</span>
//           </div>
//           <div class="total-row">
//             <span>Received Amount:</span>
//             <span>₹${formatNumber(sale.totals.netAmount)}</span>
//           </div>
//           <div class="total-row">
//             <span>Balance Amount:</span>
//             <span>₹0.00</span>
//           </div>
//         </div>
        
//         <div class="savings-row">
//           <span>💰 TODAY'S SAVINGS:</span>
//           <span>₹${formatNumber(sale.totals.discount + sale.totals.billDiscount)}</span>
//         </div>
        
//         <div class="footer">
//           🎉 Thank You, Visit Again! 🎉
//         </div>
//       </div>
      
//       <script>
//         window.onload = function() {
//           window.print();
//         }
//       </script>
//     </body>
//     </html>
//   `;

//   const newTab = window.open("", "_blank");
//   if (newTab) {
//     newTab.document.write(compactReceiptContent);
//     newTab.document.close();
//   }
// };




  
//   const printBill = () => {
//     window.print()
//   }

//   const styles = {
//     container: {
//       maxWidth: "100%",
//       margin: "0 auto",
//       padding: "2rem",
//       minHeight: "100vh",
//       fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//     },
//     header: {
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       marginBottom: "2rem",
//       padding: "1.5rem",
//       backgroundColor: "white",
//       borderRadius: "6px",
//       border: "1px solid #d1d5db",
//       fontWeight: "600",
//       color: "#374151",
//     },
//     title: {
//       fontSize: "2rem",
//       fontWeight: "700",
//       color: "#2563eb",
//       margin: "0",
//     },
//     userInfo: {
//       fontSize: "0.875rem",
//       color: "#6b7280",
//       marginTop: "0.5rem",
//     },
//     addButton: {
//       padding: "0.875rem 2rem",
//       borderRadius: "8px",
//       backgroundColor: "#2563eb",
//       color: "white",
//       fontWeight: "600",
//       cursor: "pointer",
//       border: "none",
//       fontSize: "0.95rem",
//       transition: "all 0.3s ease",
//       boxShadow: "0 4px 15px rgba(37, 99, 235, 0.3)",
//       transform: "translateY(0)",
//     },
//     tableContainer: {
//       backgroundColor: "white",
//       borderRadius: "16px",
//       overflow: "hidden",
//       boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
//       border: "1px solid #e2e8f0",
//       overflowX: "auto",
//     },
//     table: {
//       width: "100%",
//       borderCollapse: "collapse",
//       fontSize: "0.9rem",
//       border: "1px solid #d1d5db",
//     },
//     tableHeader: {
//       padding: "1rem 0.75rem",
//       textAlign: "center",
//       backgroundColor: "#2563eb",
//       color: "white",
//       fontWeight: "600",
//       fontSize: "0.85rem",
//       textTransform: "uppercase",
//       letterSpacing: "0.5px",
//       border: "1px solid #1e40af",
//     },
//     tableCell: {
//       padding: "1rem 0.75rem",
//       border: "1px solid #d1d5db",
//       color: "#374151",
//       verticalAlign: "middle",
//       textAlign: "center",
//     },
//     salesManCell: {
//       padding: "1rem 0.75rem",
//       border: "1px solid #d1d5db",
//       color: "#2563eb",
//       verticalAlign: "middle",
//       textAlign: "center",
//       fontWeight: "600",
//     },
//     actionCell: {
//       display: "flex",
//       gap: "0.5rem",
//       justifyContent: "center",
//       alignItems: "center",
//       padding: "0.5rem",
//     },
//     editButton: {
//       padding: "0.5rem",
//       borderRadius: "6px",
//       backgroundColor: "#10b981",
//       color: "white",
//       fontWeight: "500",
//       cursor: "pointer",
//       border: "none",
//       fontSize: "0.8rem",
//       transition: "all 0.2s ease",
//       boxShadow: "0 2px 8px rgba(16, 185, 129, 0.3)",
//       transform: "translateY(0)",
//     },
//     deleteButton: {
//       padding: "0.5rem",
//       borderRadius: "6px",
//       backgroundColor: "#ef4444",
//       color: "white",
//       fontWeight: "500",
//       cursor: "pointer",
//       border: "none",
//       fontSize: "0.8rem",
//       transition: "all 0.2s ease",
//       boxShadow: "0 2px 8px rgba(220, 38, 38, 0.3)",
//       transform: "translateY(0)",
//     },
//     viewButton: {
//       padding: "0.5rem",
//       borderRadius: "6px",
//       backgroundColor: "#2563eb",
//       color: "white",
//       fontWeight: "500",
//       cursor: "pointer",
//       border: "none",
//       fontSize: "0.8rem",
//       transition: "all 0.2s ease",
//       boxShadow: "0 2px 8px rgba(37, 99, 235, 0.3)",
//       transform: "translateY(0)",
//     },
//     pdfButton: {
//       padding: "0.5rem",
//       borderRadius: "6px",
//       backgroundColor: "#dc2626",
//       color: "white",
//       fontWeight: "500",
//       cursor: "pointer",
//       border: "none",
//       fontSize: "0.8rem",
//       transition: "all 0.2s ease",
//       boxShadow: "0 2px 8px rgba(220, 38, 38, 0.3)",
//       transform: "translateY(0)",
//     },
//     loading: {
//       textAlign: "center",
//       padding: "4rem",
//       color: "#718096",
//       fontSize: "1.1rem",
//     },
//     errorMessage: {
//       padding: "1rem 1.5rem",
//       marginBottom: "1.5rem",
//       borderRadius: "12px",
//       backgroundColor: "#fee2e2",
//       color: "#b91c1c",
//       border: "1px solid #fecaca",
//       fontSize: "0.9rem",
//       fontWeight: "500",
//       display: "flex",
//       alignItems: "center",
//       gap: "0.5rem",
//     },
//     noData: {
//       textAlign: "center",
//       padding: "4rem 2rem",
//       color: "#718096",
//       fontSize: "1.1rem",
//     },
//   }

//   if (!currentUser) {
//     return (
//       <div style={styles.container}>
//         <div style={{ textAlign: "center", padding: "4rem", color: "#718096", fontSize: "1.1rem" }}>
//           <h2>Please login to view sales data</h2>
//         </div>
//       </div>
//     )
//   }

//   return (
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <div>
//           <h1 style={styles.title}>Sales Management</h1>
         
//         </div>
//         <button
//           onClick={() => {
//             setShowForm(!showForm)
//             setSaleToEdit(null)
//           }}
//           style={styles.addButton}
//           onMouseEnter={(e) => {
//             e.target.style.transform = "translateY(-2px)"
//             e.target.style.boxShadow = "0 6px 20px rgba(37, 99, 235, 0.4)"
//           }}
//           onMouseLeave={(e) => {
//             e.target.style.transform = "translateY(0)"
//             e.target.style.boxShadow = "0 4px 15px rgba(37, 99, 235, 0.3)"
//           }}
//         >
//           {showForm ? "← Back to Sales" : "+ Add New Sale"}
//         </button>
//       </div>

//       {showForm && (
//         <div style={{ marginBottom: "2rem" }}>
//           <SalesForm
//             onClose={() => {
//               setShowForm(false)
//               setSaleToEdit(null)
//             }}
//             onSubmit={handleFormSubmit}
//             saleToEdit={saleToEdit}
//           />
//         </div>
//       )}

//       {!showForm && (
//         <div style={styles.tableContainer}>
//           {loading ? (
//             <div style={styles.loading}>
//               <div
//                 style={{
//                   width: "3rem",
//                   height: "3rem",
//                   border: "4px solid #e5e7eb",
//                   borderTop: "4px solid #2563eb",
//                   borderRadius: "50%",
//                   animation: "spin 1s linear infinite",
//                   margin: "0 auto 1rem",
//                 }}
//               ></div>
//               <p>⏳ Loading sales...</p>
//             </div>
//           ) : error ? (
//             <div style={styles.errorMessage}>
//               <span>❌</span>
//               {error}
//             </div>
//           ) : salesData.length > 0 ? (
//             <table style={styles.table}>
//               <thead>
//                 <tr>
//                   <th style={styles.tableHeader}>BILL NO</th>
//                   <th style={styles.tableHeader}>DATE</th>
//                   <th style={styles.tableHeader}>TERMS</th>
//                   <th style={styles.tableHeader}>SALES MAN</th>
//                   <th style={styles.tableHeader}>CUSTOMER</th>
//                   <th style={styles.tableHeader}>PHONE</th>
//                   <th style={styles.tableHeader}>GROSS AMT</th>
//                   <th style={styles.tableHeader}>DISCOUNT</th>
//                   <th style={styles.tableHeader}>BILL DISCOUNT</th>
//                   <th style={styles.tableHeader}>TOTAL TAX</th>
//                   <th style={styles.tableHeader}>NET AMOUNT</th>
//                   <th style={styles.tableHeader}>ACTION</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {salesData.map((sale, index) => (
//                   <tr
//                     key={sale.id}
//                     style={{
//                       backgroundColor: index % 2 === 0 ? "#f7fafc" : "white",
//                       transition: "background-color 0.2s ease",
//                     }}
//                   >
//                     <td style={styles.tableCell}>{sale.billNo}</td>
//                     <td style={styles.tableCell}>{sale.date}</td>
//                     <td style={styles.tableCell}>{sale.terms}</td>
//                     <td style={styles.salesManCell}>{sale.salesMan || currentUserName || "N/A"}</td>
//                     <td style={styles.tableCell}>{sale.customer}</td>
//                     <td style={styles.tableCell}>{sale.phone}</td>
//                     <td style={styles.tableCell}>₹{formatNumber(sale.totals.grossAmt)}</td>
//                     <td style={styles.tableCell}>₹{formatNumber(sale.totals.discount)}</td>
//                     <td style={styles.tableCell}>₹{formatNumber(sale.totals.billDiscount)}</td>
//                     <td style={styles.tableCell}>₹{formatNumber(sale.totals.totalTax)}</td>
//                     <td style={styles.tableCell}>
//                       <strong>₹{formatNumber(sale.totals.netAmount)}</strong>
//                     </td>
//                     <td style={styles.actionCell}>
//                       <button
//                         onClick={() => handleView(sale)}
//                         style={styles.viewButton}
//                         title="View Details"
//                         onMouseEnter={(e) => {
//                           e.target.style.transform = "translateY(-1px)"
//                           e.target.style.boxShadow = "0 4px 12px rgba(37, 99, 235, 0.4)"
//                         }}
//                         onMouseLeave={(e) => {
//                           e.target.style.transform = "translateY(0)"
//                           e.target.style.boxShadow = "0 2px 8px rgba(37, 99, 235, 0.3)"
//                         }}
//                       >
//                         👁
//                       </button>
//                       <button
//                         onClick={() => downloadPDF(sale)}
//                         style={styles.pdfButton}
//                         title="Download PDF"
//                         onMouseEnter={(e) => {
//                           e.target.style.transform = "translateY(-1px)"
//                           e.target.style.boxShadow = "0 4px 12px rgba(220, 38, 38, 0.4)"
//                         }}
//                         onMouseLeave={(e) => {
//                           e.target.style.transform = "translateY(0)"
//                           e.target.style.boxShadow = "0 2px 8px rgba(220, 38, 38, 0.3)"
//                         }}
//                       >
//                         📄
//                       </button>
//                       <button
//                         onClick={() => handleEdit(sale)}
//                         style={styles.editButton}
//                         title="Edit Sale"
//                         onMouseEnter={(e) => {
//                           e.target.style.transform = "translateY(-1px)"
//                           e.target.style.boxShadow = "0 4px 12px rgba(16, 185, 129, 0.4)"
//                         }}
//                         onMouseLeave={(e) => {
//                           e.target.style.transform = "translateY(0)"
//                           e.target.style.boxShadow = "0 2px 8px rgba(16, 185, 129, 0.3)"
//                         }}
//                       >
//                         ✏️
//                       </button>
//                       <button
//                         onClick={() => handleDelete(sale.id)}
//                         style={styles.deleteButton}
//                         title="Delete Sale"
//                         onMouseEnter={(e) => {
//                           e.target.style.transform = "translateY(-1px)"
//                           e.target.style.boxShadow = "0 4px 12px rgba(220, 38, 38, 0.4)"
//                         }}
//                         onMouseLeave={(e) => {
//                           e.target.style.transform = "translateY(0)"
//                           e.target.style.boxShadow = "0 2px 8px rgba(220, 38, 38, 0.3)"
//                         }}
//                       >
//                         🗑️
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           ) : (
//             <div style={styles.noData}>
//               <div style={{ fontSize: "4rem", marginBottom: "1rem", opacity: "0.5" }}>📄</div>
//               <h3 style={{ color: "#4a5568", marginBottom: "0.5rem" }}>No Sales Found</h3>
//               <p style={{ marginBottom: "1.5rem" }}>Get started by adding your first sale!</p>
//               <button
//                 onClick={() => {
//                   setShowForm(true)
//                   setSaleToEdit(null)
//                 }}
//                 style={{
//                   ...styles.addButton,
//                   fontSize: "1rem",
//                   padding: "1rem 2rem",
//                 }}
//                 onMouseEnter={(e) => {
//                   e.target.style.transform = "translateY(-2px)"
//                   e.target.style.boxShadow = "0 6px 20px rgba(37, 99, 235, 0.4)"
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.transform = "translateY(0)"
//                   e.target.style.boxShadow = "0 4px 15px rgba(37, 99, 235, 0.3)"
//                 }}
//               >
//                 + Add Your First Sale
//               </button>
//             </div>
//           )}
//         </div>
//       )}

//       <style jsx>{`
//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }
//         @media (max-width: 768px) {
//           .header { flex-direction: column; alignItems: flex-start; gap: 1rem; }
//           .addButton { width: 100%; text-align: center; }
//         }
//         button:hover:not(:disabled) { filter: brightness(90%); }
//         @media print {
//           .billModal { position: static !important; background: none !important; padding: 0 !important; }
//           .billContainer { width: 100% !important; max-width: none !important; max-height: none !important; overflow: visible !important; box-shadow: none !important; border-radius: 0 !important; }
//           .billHeader { display: none !important; }
//           .invoice { padding: 0 !important; font-size: 10px !important; }
//         }
//       `}</style>
//     </div>
//   )
// }

// export default SalesTable


import { useState, useEffect } from "react"
import SalesForm from "./SalesForm"
import { auth, database } from "../firebase"
import { ref, onValue, remove, get, update } from "firebase/database"

const SalesTable = () => {
  const [showForm, setShowForm] = useState(false)
  const [salesData, setSalesData] = useState([])
  const [currentUser, setCurrentUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [saleToEdit, setSaleToEdit] = useState(null)
  const [branchProfile, setBranchProfile] = useState(null)
  const [currentUserName, setCurrentUserName] = useState('')

  const encodeEmailForPath = (email) => {
    return email.replace(/[.#$[\]]/g, "_")
  }

  const formatNumber = (value) => {
    const num = Number.parseFloat(value)
    return isNaN(num) ? (0).toFixed(2) : num.toFixed(2)
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return ""
    const parts = dateStr.split("-")
    if (parts.length === 3) {
      return `${parts[0]}-${parts[1]}-${parts[2]}`
    }
    return dateStr
  }

  const formatDateTimeForReceipt = (dateStr) => {
    if (!dateStr) return { date: "", time: "" }
    const now = new Date()
    const date = formatDate(dateStr)
    const time = now.toLocaleTimeString("en-IN", {
      hour12: true,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
    return { date, time }
  }

  // Function to get product details including HSN/SAC code, Label No, and Type
 const getProductDetails = async (productName) => {
    if (!currentUser || !productName) return { hsnSacCode: "N/A", labelNo: "N/A", type: "N/A" }
    
    try {
      const encodedEmail = encodeEmailForPath(currentUser.email)
      const productsRef = ref(database, `users/${encodedEmail}/products`)
      const snapshot = await get(productsRef)
      
      if (snapshot.exists()) {
        const products = snapshot.val()
        const product = Object.values(products).find(p => p.productName === productName)
        return {
          hsnSacCode: product?.hsnSacCode || "N/A",
          labelNo: product?.labelNo || "N/A",
          type: product?.type || "N/A",
          typeMultiplier: product?.typeMultiplier || "1"
        }
      }
      return { hsnSacCode: "N/A", labelNo: "N/A", type: "N/A", typeMultiplier: "1" }
    } catch (error) {
      console.error("Error fetching product details:", error)
      return { hsnSacCode: "N/A", labelNo: "N/A", type: "N/A", typeMultiplier: "1" }
    }
  }


  // Fetch current user
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user)
      setLoading(false)
    })
    return () => unsubscribe()
  }, [])

  // Fetch current user's name from employee data or profile
  useEffect(() => {
    if (!currentUser) {
      setCurrentUserName('')
      return
    }

    const encodedEmail = encodeEmailForPath(currentUser.email)

    // First, check if user has a profile (for employees)
    const userProfileRef = ref(database, `users/${encodedEmail}/profile`)
    const unsubscribeProfile = onValue(userProfileRef, (snapshot) => {
      const profileData = snapshot.val()
      if (profileData && profileData.personalInfo && profileData.personalInfo.name) {
        setCurrentUserName(profileData.personalInfo.name)
        return
      }

      // If no profile found or no name in profile, check if user is in someone's employee list
      const checkAsEmployee = async () => {
        try {
          const usersRef = ref(database, 'users')
          const usersSnapshot = await get(usersRef)
          
          if (usersSnapshot.exists()) {
            const users = usersSnapshot.val()
            let foundEmployeeName = null

            for (const [userKey, userData] of Object.entries(users)) {
              if (userData.employees) {
                for (const [employeeId, employeeData] of Object.entries(userData.employees)) {
                  if (employeeData.email === currentUser.email) {
                    foundEmployeeName = employeeData.name
                    break
                  }
                }
                if (foundEmployeeName) break
              }
            }

            if (foundEmployeeName) {
              setCurrentUserName(foundEmployeeName)
            } else {
              const defaultName = currentUser.email.split('@')[0].toUpperCase()
              setCurrentUserName(defaultName)
            }
          }
        } catch (error) {
          console.error('Error checking employee data:', error)
          const defaultName = currentUser.email.split('@')[0].toUpperCase()
          setCurrentUserName(defaultName)
        }
      }

      checkAsEmployee()
    }, (error) => {
      console.error('Error fetching user profile:', error)
      if (currentUser) {
        const defaultName = currentUser.email.split('@')[0].toUpperCase()
        setCurrentUserName(defaultName)
      }
    })

    return () => unsubscribeProfile()
  }, [currentUser])

  // Fetch branch profile data
  useEffect(() => {
    if (!currentUser) {
      setBranchProfile(null)
      return
    }

    const encodedEmail = encodeEmailForPath(currentUser.email)
    const branchProfilesRef = ref(database, `users/${encodedEmail}/branchProfiles`)
    const unsubscribe = onValue(branchProfilesRef, (snapshot) => {
      try {
        const data = snapshot.val()
        if (data) {
          const profiles = Object.entries(data)
          const latestProfile = profiles[profiles.length - 1]
          setBranchProfile(latestProfile[1])
        } else {
          setBranchProfile(null)
        }
      } catch (err) {
        console.error("Error fetching branch profile:", err)
        setBranchProfile(null)
      }
    })

    return () => unsubscribe()
  }, [currentUser])

  // Fetch sales data from Firebase
  useEffect(() => {
    if (!currentUser) {
      setSalesData([])
      setLoading(false)
      return
    }

    setLoading(true)
    const encodedEmail = encodeEmailForPath(currentUser.email)
    const salesRef = ref(database, `users/${encodedEmail}/sales`)

    const unsubscribe = onValue(
      salesRef,
      (snapshot) => {
        try {
          const data = snapshot.val()
          if (data) {
            const salesList = Object.keys(data)
              .map((key) => ({
                id: key,
                ...data[key],
                totals: {
                  grossAmt: Number.parseFloat(data[key].totals?.grossAmt) || 0,
                  discount: Number.parseFloat(data[key].totals?.discount) || 0,
                  billDiscount: Number.parseFloat(data[key].totals?.billDiscount) || 0,
                  totalTax: Number.parseFloat(data[key].totals?.totalTax) || 0,
                  netAmount: Number.parseFloat(data[key].totals?.netAmount) || 0,
                },
              }))
              .filter((sale) => sale.billNo && sale.date)
            setSalesData(salesList)
            setError(null)
          } else {
            setSalesData([])
            setError(null)
          }
          setLoading(false)
        } catch (err) {
          console.error("Error processing sales data:", err)
          setError("Failed to load sales data.")
          setSalesData([])
          setLoading(false)
        }
      },
      (error) => {
        console.error("Firebase error:", error)
        setError("Failed to fetch sales data.")
        setSalesData([])
        setLoading(false)
      },
    )

    return () => unsubscribe()
  }, [currentUser])

  // Restore product stock when a sale is deleted
  const restoreProductStock = async (saleData, encodedEmail) => {
    try {
      const productsRef = ref(database, `users/${encodedEmail}/products`)
      const snapshot = await get(productsRef)
      const products = snapshot.exists()
        ? Object.keys(snapshot.val()).map((key) => ({
            id: key,
            ...snapshot.val()[key],
          }))
        : []

      for (const item of saleData.items) {
        const product = products.find((p) => p.productName === item.itemDescription)
        if (product && item.qty) {
          const qtySold = Number.parseFloat(item.qty) || 0
          const currentStock = Number.parseFloat(product.openingStock) || 0
          const restoredStock = currentStock + qtySold

          const productRef = ref(database, `users/${encodedEmail}/products/${product.id}`)
          await update(productRef, { openingStock: restoredStock.toString() })
          console.log(`Restored stock for ${product.productName}: ${restoredStock}`)
        }
      }
    } catch (error) {
      console.error("Error restoring product stock:", error)
      throw new Error("Failed to restore product stock")
    }
  }

  const handleFormSubmit = () => {
    setShowForm(false)
    setSaleToEdit(null)
  }

  const handleEdit = (sale) => {
    setSaleToEdit(sale)
    setShowForm(true)
  }

  const handleDelete = async (saleId) => {
    if (!window.confirm("Are you sure you want to delete this sale?")) return

    if (!currentUser) {
      setError("No user is logged in.")
      return
    }

    const encodedEmail = encodeEmailForPath(currentUser.email)
    const saleRef = ref(database, `users/${encodedEmail}/sales/${saleId}`)

    try {
      const snapshot = await get(saleRef)
      if (!snapshot.exists()) {
        setError("Sale not found.")
        return
      }

      const saleData = snapshot.val()
      await restoreProductStock(saleData, encodedEmail)
      await remove(saleRef)
      setError(null)
      setSalesData((prev) => prev.filter((sale) => sale.id !== saleId))
      alert('Sale deleted successfully!')
    } catch (error) {
      console.error("Error deleting sale:", error)
      setError(`Failed to delete sale: ${error.message}`)
      alert(`Error: ${error.message}`)
    }
  }

// Modified handleView function
const handleView = async (sale) => {
  const itemsWithDetails = await Promise.all(
    sale.items.map(async (item) => {
      const details = await getProductDetails(item.itemDescription)
      return { ...item, ...details, typeDisplay: item.type || details.type || "N/A" }
    })
  )

  const billContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        body {
          font-family: Arial, sans-serif;
          font-size: 10px;
          line-height: 1.3;
          color: #000;
          background-color: white;
          margin: 0;
          padding: 10px;
        }
        .invoice {
          max-width: 800px;
          margin: 0 auto;
          border: 1px solid #3b82f6;
          border-radius: 8px;
          padding: 15px;
          background-color: white;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          font-family: Arial, sans-serif;
          font-size: 10px;
          page-break-inside: avoid;
        }
        .invoice-header {
          text-align: center;
          margin-bottom: 15px;
          padding-bottom: 10px;
          border-bottom: 1px solid #e2e8f0;
        }
        .company-name {
          font-size: 18px;
          font-weight: bold;
          margin: 0;
          margin-bottom: 3px;
          color: #1e293b;
          text-shadow: 1px 1px 1px rgba(0,0,0,0.1);
        }
        .company-details {
          font-size: 10px;
          color: #475569;
          margin: 3px 0;
        }
        .tax-invoice {
          font-size: 12px;
          font-weight: 600;
          color: #3b82f6;
          margin-top: 5px;
        }
        .invoice-info {
          display: flex;
          justify-content: space-between;
          margin: 10px 0;
          padding: 10px;
          background-color: #f8fafc;
          border-radius: 6px;
          border: 1px solid #e2e8f0;
        }
        .invoice-info-left, .invoice-info-right {
          width: 48%;
          font-size: 10px;
        }
        .invoice-info-right {
          text-align: right;
        }
        .customer-section {
          margin-bottom: 10px;
          font-size: 10px;
        }
        .items-table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 15px;
          border: 1px solid #3b82f6;
          border-radius: 6px;
          overflow: hidden;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          page-break-inside: avoid;
          table-layout: fixed;
        }
        .items-table th {
          border: 1px solid #cbd5e1;
          padding: 6px 4px;
          background-color: #f1f5f9;
          font-weight: 600;
          text-align: center;
          font-size: 9px;
          color: #1e293b;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          word-wrap: break-word;
        }
        .items-table th:nth-child(1) { width: 5%; }
        .items-table th:nth-child(2) { width: 25%; }
        .items-table th:nth-child(3) { width: 10%; }
        .items-table th:nth-child(4) { width: 10%; }
        .items-table th:nth-child(5) { width: 10%; }
        .items-table th:nth-child(6) { width: 8%; }
        .items-table th:nth-child(7) { width: 10%; }
        .items-table th:nth-child(8) { width: 7%; }
        .items-table th:nth-child(9) { width: 15%; }
        .items-table td {
          border: 1px solid #cbd5e1;
          padding: 5px 4px;
          vertical-align: middle;
          font-size: 9px;
          line-height: 1.1;
          word-wrap: break-word;
          overflow: hidden;
        }
        .items-table td.left {
          text-align: left;
        }
        .items-table td.right {
          text-align: right;
        }
        .items-table td.center {
          text-align: center;
        }
        .items-table tbody tr:nth-child(even) {
          background-color: #f8fafc;
        }
        .items-table tbody tr:hover {
          background-color: #f1f5f9;
        }
        .total-section {
          display: flex;
          justify-content: space-between;
          margin-bottom: 15px;
          gap: 10px;
        }
        .bank-details {
          width: 48%;
          font-size: 9px;
          padding: 10px;
          background-color: #f8fafc;
          border-radius: 6px;
          border: 1px solid #e2e8f0;
          word-wrap: break-word;
        }
        .total-box {
          width: 48%;
          font-size: 10px;
          padding: 10px;
          background-color: #f8fafc;
          border-radius: 6px;
          border: 1px solid #e2e8f0;
        }
        .total-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 4px;
          padding: 3px 0;
        }
        .net-total-row {
          display: flex;
          justify-content: space-between;
          font-weight: bold;
          border-top: 1px solid #3b82f6;
          padding-top: 5px;
          margin-top: 5px;
          font-size: 11px;
          color: #1e293b;
        }
        .terms-section {
          font-size: 9px;
          margin-bottom: 15px;
          line-height: 1.2;
          padding: 10px;
          background-color: #f8fafc;
          border-radius: 6px;
          border: 1px solid #e2e8f0;
          word-wrap: break-word;
        }
        .signature-section {
          text-align: right;
          font-size: 10px;
          margin-top: 20px;
          padding: 10px;
        }
        .footer {
          text-align: center;
          font-size: 8px;
          margin-top: 15px;
          color: #64748b;
          font-style: italic;
          border-top: 1px solid #e2e8f0;
          padding-top: 10px;
        }
        @media print {
          body {
            margin: 0;
            padding: 0;
          }
          .invoice {
            border: none;
            box-shadow: none;
            padding: 5px;
            margin: 0;
            max-width: none;
            font-size: 9px;
            transform: scale(0.95);
            transform-origin: top;
            page-break-inside: avoid;
          }
          .items-table {
            page-break-inside: avoid;
          }
          .total-section, .terms-section, .signature-section, .footer {
            page-break-inside: avoid;
          }
          @page {
            margin: 0.5cm;
          }
        }
      </style>
    </head>
    <body>
      <div class="invoice">
        <div class="invoice-header">
          <div class="company-name">${branchProfile?.branchName || "SUPREME TRADERS"}</div>
          <div class="company-details">
            ${branchProfile?.address1 && `${branchProfile.address1}`}
            ${branchProfile?.address2 && `, ${branchProfile.address2}`}<br/>
            ${branchProfile?.city || "SALEM"} - ${branchProfile?.zipCode || "123456"}<br/>
            Ph: ${branchProfile?.phoneNo || "7708970307"}<br/>
            GSTIN: ${branchProfile?.gstinNo || "33AVSPV4056G1Z4"}
          </div>
          <div class="tax-invoice">TAX INVOICE</div>
        </div>
        
        <div class="invoice-info">
          <div class="invoice-info-left">
            <strong>TO:</strong><br/>
            <strong>${sale.customer || "WALK-IN CUSTOMER"}</strong><br/>
            <strong>Phone:</strong> ${sale.phone || "N/A"}
          </div>
          <div class="invoice-info-right">
            <strong>Date:</strong> ${formatDate(sale.date)}<br/>
            <strong>Bill No:</strong> ${sale.billNo}<br/>
            <strong>Bill Type:</strong> ${sale.terms || "CASH"}<br/>
            <strong>Sales Person:</strong> ${sale.salesMan || currentUserName || "N/A"}
          </div>
        </div>

        <table class="items-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Item Description</th>
                  <th>HSN/SAC</th>
              <th>Label No</th>
              <th>Type</th>
          
              <th>Quantity</th>
              <th>Rate</th>
              <th>GST</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            ${
              itemsWithDetails &&
              itemsWithDetails
                .map(
                  (item, index) => `
                <tr>
                  <td class="center">${index + 1}</td>
                  <td class="left">${item.itemDescription || "N/A"}</td>
                    <td class="center">${item.hsnSacCode || "N/A"}</td>
                  <td class="center">${item.labelNo || "N/A"}</td>
                  <td class="center">${item.typeDisplay || "N/A"}</td>
                
                  <td class="right">${item.qty || "0"}</td>
                  <td class="right">₹${formatNumber(item.unitRate || 0)}</td>
                  <td class="center">${item.tax || "0"}%</td>
                  <td class="right">₹${formatNumber(item.netValue || 0)}</td>
                </tr>
              `,
                )
                .join("")
            }
            <tr style="background-color: #fef3c7; font-weight: bold; border-top: 1px solid #f59e0b;">
              <td class="center" style="font-weight: bold;"></td>
              <td class="left" style="font-weight: bold;">Total Items: ${sale.items ? sale.items.length : 0}</td>
              <td class="center" style="font-weight: bold;"></td>
              <td class="center" style="font-weight: bold;"></td>
              <td class="center" style="font-weight: bold;"></td>
              <td class="right" style="font-weight: bold;">${sale.items ? sale.items.reduce((sum, item) => sum + (Number.parseFloat(item.qty) || 0), 0) : 0}</td>
              <td colspan="2" class="right" style="font-weight: bold;">Gross Amount:</td>
              <td class="right" style="font-weight: bold;">₹${formatNumber(sale.totals.grossAmt)}</td>
            </tr>
          </tbody>
        </table>

        <div class="total-section">
          <div class="bank-details">
            <strong>Company's Bank Details:</strong><br/><br/>
            <strong>Bank Name:</strong> ${branchProfile?.bankName || "SHRISWAPAY"}<br/>
            <strong>A/C No:</strong> ${branchProfile?.accountNo || "614405018162"}<br/>
            <strong>Branch Name:</strong> ${branchProfile?.bankBranchName || "NETHIMEDU"}<br/>
            <strong>IFSC Code:</strong> ${branchProfile?.ifscCode || "ICIC0006144"}<br/>
            <strong>MICR Code:</strong> ${branchProfile?.micrCode || "MICR CODE"}<br/>
            <br/>
            <strong>Declarations:</strong><br/>
            • Goods once sold will not be taken back or exchanged<br/>
            • E&OE<br/>
            • Subject to ${branchProfile?.city?.toUpperCase() || "SALEM"} jurisdiction
          </div>
          
          <div class="total-box">
            <div class="total-row">
              <span>CGST:</span>
              <span>₹${formatNumber(sale.totals.totalTax / 2)}</span>
            </div>
            <div class="total-row">
              <span>SGST:</span>
              <span>₹${formatNumber(sale.totals.totalTax / 2)}</span>
            </div>
            <div class="total-row">
              <span>Discount:</span>
              <span>₹${formatNumber(sale.totals.discount)}</span>
            </div>
            <div class="total-row">
              <span>Bill Discount:</span>
              <span>₹${formatNumber(sale.totals.billDiscount)}</span>
            </div>
            <div class="total-row">
              <span>Rounded Off:</span>
              <span>₹0.00</span>
            </div>
            <div class="net-total-row">
              <span>NET TOTAL:</span>
              <span>₹${formatNumber(sale.totals.netAmount)}</span>
            </div>
          </div>
        </div>

        <div class="terms-section">
          <strong>Terms & Conditions:</strong><br/>
          1. Goods once sold will not be taken back or exchanged.<br/>
          2. All disputes are subject to local jurisdiction.<br/>
          3. Payment terms: ${sale.terms || "CASH"}<br/>
          ${sale.remarks ? `4. <strong>Remarks:</strong> ${sale.remarks}<br/>` : ''}
          ${sale.otherDetails ? `5. <strong>Other Details:</strong> ${sale.otherDetails}<br/>` : ''}
        </div>

        <div class="signature-section">
          <strong>For ${branchProfile?.branchName || "SUPREME TRADERS"}</strong><br/>
          <br/>
          <br/>
          <strong>Authorized Signatory</strong>
        </div>

        <div class="footer">
          This is a computer generated invoice
        </div>
      </div>
      
      <script>
        window.onload = function() {
          window.print();
        }
      </script>
    </body>
    </html>
  `

  const newTab = window.open("", "_blank")
  if (newTab) {
    newTab.document.write(billContent)
    newTab.document.close()
  }
}

// Modified downloadPDF function
const downloadPDF = async (sale) => {
  const { date, time } = formatDateTimeForReceipt(sale.date)
  const totalQty = sale.items ? sale.items.reduce((sum, item) => sum + (Number.parseInt(item.qty) || 0), 0) : 0
  const totalItems = sale.items ? sale.items.length : 0
  const cgstAmount = formatNumber(sale.totals.totalTax / 2)
  const sgstAmount = formatNumber(sale.totals.totalTax / 2)

  const itemsWithDetails = await Promise.all(
    sale.items.map(async (item) => {
      const details = await getProductDetails(item.itemDescription)
      return { ...item, ...details, typeDisplay: item.type || details.type || "N/A" }
    })
  )

  const compactReceiptContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        * {
          box-sizing: border-box;
        }
        body {
          font-family: Arial, sans-serif;
          font-size: 14px;
          line-height: 1.4;
          color: #000;
          background-color: white;
          margin: 0;
          padding: 20px;
        }
        .receipt {
          max-width: 600px;
          margin: 0 auto;
          border: 2px solid #3b82f6;
          border-radius: 12px;
          padding: 20px;
          background-color: white;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
          font-family: Arial, sans-serif;
          page-break-inside: avoid;
        }
        .header {
          text-align: center;
          margin-bottom: 20px;
          padding-bottom: 15px;
          border-bottom: 2px solid #e2e8f0;
        }
        .company-name {
          font-size: 22px;
          font-weight: bold;
          margin: 10px 0;
          color: #1e293b;
          text-shadow: 1px 1px 2px rgba(0,0,0,0.1);
        }
        .company-details {
          font-size: 12px;
          margin: 5px 0;
          color: #475569;
        }
        .invoice-info {
          display: flex;
          justify-content: space-between;
          margin: 15px 0;
          font-size: 13px;
          font-weight: 600;
          padding: 12px;
          background-color: #f8fafc;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
        }
        .items-section {
          margin: 20px 0;
          overflow-x: auto;
        }
        .items-header {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 0.8fr 0.8fr 1fr;
          gap: 8px;
          font-weight: bold;
          background-color: #f1f5f9;
          padding: 10px 8px;
          font-size: 11px;
          border: 1px solid #cbd5e1;
          border-radius: 8px 8px 0 0;
          color: #1e293b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          text-align: center;
        }
        .items-header span:first-child {
          text-align: left;
        }
        .items-header span:last-child {
          text-align: right;
        }
        .item-row {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 0.8fr 0.8fr 1fr;
          gap: 8px;
          padding: 10px 8px;
          font-size: 11px;
          border: 1px solid #cbd5e1;
          border-top: none;
          background-color: white;
          align-items: center;
          text-align: center;
          word-wrap: break-word;
        }
        .item-row span:first-child {
          text-align: left;
          font-weight: 500;
        }
        .item-row span:last-child {
          text-align: right;
        }
        .item-row:nth-child(even) {
          background-color: #f8fafc;
        }
        .item-row:hover {
          background-color: #f1f5f9;
        }
        .summary-row {
          font-weight: bold;
          background-color: #fef3c7 !important;
          border-top: 2px solid #f59e0b !important;
          font-size: 12px;
        }
        .totals-section {
          margin-top: 20px;
          padding: 15px;
          background-color: #f8fafc;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
        }
        .total-row {
          display: flex;
          justify-content: space-between;
          margin: 8px 0;
          font-size: 13px;
          padding: 5px 0;
        }
        .net-total {
          font-weight: bold;
          border-top: 2px solid #3b82f6;
          padding-top: 12px;
          margin-top: 12px;
          font-size: 15px;
          color: #1e293b;
        }
        .savings-row {
          display: flex;
          justify-content: space-between;
          font-weight: bold;
          margin: 20px 0;
          font-size: 15px;
          padding: 12px;
          background-color: #ecfdf5;
          border-radius: 8px;
          border: 1px solid #10b981;
          color: #047857;
        }
        .footer {
          text-align: center;
          font-weight: bold;
          margin-top: 20px;
          font-size: 15px;
          color: #3b82f6;
          border-top: 2px solid #e2e8f0;
          padding-top: 15px;
        }
        @media print {
          .receipt {
            border: none;
            box-shadow: none;
            padding: 10px;
            margin: 0;
            max-width: none;
          }
          body {
            margin: 0;
            padding: 0;
          }
        }
      </style>
    </head>
    <body>
      <div class="receipt">
        <div class="header">
          <div class="company-name">${branchProfile?.branchName || "SuperMarket"}</div>
          <div class="company-details">City: ${branchProfile?.city || "Salem"}</div>
          <div class="company-details">ZIP Code: ${branchProfile?.zipCode || "414001"}</div>
          <div class="company-details">Call: ${branchProfile?.phoneNo || "7708970307"}</div>
          <div class="company-details">GSTIN: ${branchProfile?.gstinNo || "33AVSPV4056G1Z4"}</div>
        </div>
        
        <div class="invoice-info">
          <span>Invoice No: ${sale.billNo}</span>
          <span>Date: ${date}</span>
        </div>
        
        <div class="items-section">
          <div class="items-header">
            <span>ITEMS</span>
            <span>LABEL</span>
            <span>TYPE</span>
            <span>RATE</span>
            <span>QTY</span>
            <span>AMOUNT</span>
          </div>
          
          ${itemsWithDetails && itemsWithDetails.map((item) => `
            <div class="item-row">
              <span>${(item.itemDescription || "N/A").toUpperCase()}</span>
              <span>${item.labelNo || "N/A"}</span>
              <span>${item.typeDisplay || "N/A"}</span>
              <span>₹${formatNumber(item.unitRate || 0)}</span>
              <span>${item.qty || "0"}</span>
              <span>₹${formatNumber(item.netValue || 0)}</span>
            </div>
          `).join('')}
          
          <div class="item-row summary-row">
            <span>🛒 ${totalItems} Items</span>
            <span></span>
            <span></span>
            <span></span>
            <span>${totalQty}</span>
            <span>₹${formatNumber(sale.totals.grossAmt)}</span>
          </div>
        </div>
        
        <div class="totals-section">
          <div class="total-row">
            <span>CGST Tax:</span>
            <span>₹${cgstAmount}</span>
          </div>
          <div class="total-row">
            <span>SGST Tax:</span>
            <span>₹${sgstAmount}</span>
          </div>
          <div class="total-row">
            <span>Discount:</span>
            <span>₹${formatNumber(sale.totals.discount)}</span>
          </div>
          <div class="total-row">
            <span>Bill Discount:</span>
            <span>₹${formatNumber(sale.totals.billDiscount)}</span>
          </div>
          <div class="total-row net-total">
            <span>NET TOTAL:</span>
            <span>₹${formatNumber(sale.totals.netAmount)}</span>
          </div>
          <div class="total-row">
            <span>Received Amount:</span>
            <span>₹${formatNumber(sale.totals.netAmount)}</span>
          </div>
          <div class="total-row">
            <span>Balance Amount:</span>
            <span>₹0.00</span>
          </div>
        </div>
        
        <div class="savings-row">
          <span>💰 TODAY'S SAVINGS:</span>
          <span>₹${formatNumber(sale.totals.discount + sale.totals.billDiscount)}</span>
        </div>
        
        <div class="footer">
          🎉 Thank You, Visit Again! 🎉
        </div>
      </div>
      
      <script>
        window.onload = function() {
          window.print();
        }
      </script>
    </body>
    </html>
  `

  const newTab = window.open("", "_blank")
  if (newTab) {
    newTab.document.write(compactReceiptContent)
    newTab.document.close()
  }
}

  const styles = {
    container: {
      maxWidth: "100%",
      margin: "0 auto",
      padding: "2rem",
      minHeight: "100vh",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "2rem",
      padding: "1.5rem",
      backgroundColor: "white",
      borderRadius: "6px",
      border: "1px solid #d1d5db",
      fontWeight: "600",
      color: "#374151",
    },
    title: {
      fontSize: "2rem",
      fontWeight: "700",
      color: "#2563eb",
      margin: "0",
    },
    userInfo: {
      fontSize: "0.875rem",
      color: "#6b7280",
      marginTop: "0.5rem",
    },
    addButton: {
      padding: "0.875rem 2rem",
      borderRadius: "8px",
      backgroundColor: "#2563eb",
      color: "white",
      fontWeight: "600",
      cursor: "pointer",
      border: "none",
      fontSize: "0.95rem",
      transition: "all 0.3s ease",
      boxShadow: "0 4px 15px rgba(37, 99, 235, 0.3)",
      transform: "translateY(0)",
    },
    tableContainer: {
      backgroundColor: "white",
      borderRadius: "16px",
      overflow: "hidden",
      boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e2e8f0",
      overflowX: "auto",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      fontSize: "0.9rem",
      border: "1px solid #d1d5db",
    },
    tableHeader: {
      padding: "1rem 0.75rem",
      textAlign: "center",
      backgroundColor: "#2563eb",
      color: "white",
      fontWeight: "600",
      fontSize: "0.85rem",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      border: "1px solid #1e40af",
    },
    tableCell: {
      padding: "1rem 0.75rem",
      border: "1px solid #d1d5db",
      color: "#374151",
      verticalAlign: "middle",
      textAlign: "center",
    },
    salesManCell: {
      padding: "1rem 0.75rem",
      border: "1px solid #d1d5db",
      color: "#2563eb",
      verticalAlign: "middle",
      textAlign: "center",
      fontWeight: "600",
    },
    actionCell: {
      display: "flex",
      gap: "0.5rem",
      justifyContent: "center",
      alignItems: "center",
      padding: "0.5rem",
    },
    editButton: {
      padding: "0.5rem",
      borderRadius: "6px",
      backgroundColor: "#10b981",
      color: "white",
      fontWeight: "500",
      cursor: "pointer",
      border: "none",
      fontSize: "0.8rem",
      transition: "all 0.2s ease",
      boxShadow: "0 2px 8px rgba(16, 185, 129, 0.3)",
      transform: "translateY(0)",
    },
    deleteButton: {
      padding: "0.5rem",
      borderRadius: "6px",
      backgroundColor: "#ef4444",
      color: "white",
      fontWeight: "500",
      cursor: "pointer",
      border: "none",
      fontSize: "0.8rem",
      transition: "all 0.2s ease",
      boxShadow: "0 2px 8px rgba(220, 38, 38, 0.3)",
      transform: "translateY(0)",
    },
    viewButton: {
      padding: "0.5rem",
      borderRadius: "6px",
      backgroundColor: "#2563eb",
      color: "white",
      fontWeight: "500",
      cursor: "pointer",
      border: "none",
      fontSize: "0.8rem",
      transition: "all 0.2s ease",
      boxShadow: "0 2px 8px rgba(37, 99, 235, 0.3)",
      transform: "translateY(0)",
    },
    pdfButton: {
      padding: "0.5rem",
      borderRadius: "6px",
      backgroundColor: "#dc2626",
      color: "white",
      fontWeight: "500",
      cursor: "pointer",
      border: "none",
      fontSize: "0.8rem",
      transition: "all 0.2s ease",
      boxShadow: "0 2px 8px rgba(220, 38, 38, 0.3)",
      transform: "translateY(0)",
    },
    loading: {
      textAlign: "center",
      padding: "4rem",
      color: "#718096",
      fontSize: "1.1rem",
    },
    errorMessage: {
      padding: "1rem 1.5rem",
      marginBottom: "1.5rem",
      borderRadius: "12px",
      backgroundColor: "#fee2e2",
      color: "#b91c1c",
      border: "1px solid #fecaca",
      fontSize: "0.9rem",
      fontWeight: "500",
      display: "flex",
      alignItems: "center",
      gap: "0.5rem",
    },
    noData: {
      textAlign: "center",
      padding: "4rem 2rem",
      color: "#718096",
      fontSize: "1.1rem",
    },
  }

  if (!currentUser) {
    return (
      <div style={styles.container}>
        <div style={{ textAlign: "center", padding: "4rem", color: "#718096", fontSize: "1.1rem" }}>
          <h2>Please login to view sales data</h2>
        </div>
      </div>
    )
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>Sales Management</h1>
        </div>
        <button
          onClick={() => {
            setShowForm(!showForm)
            setSaleToEdit(null)
          }}
          style={styles.addButton}
          onMouseEnter={(e) => {
            e.target.style.transform = "translateY(-2px)"
            e.target.style.boxShadow = "0 6px 20px rgba(37, 99, 235, 0.4)"
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "translateY(0)"
            e.target.style.boxShadow = "0 4px 15px rgba(37, 99, 235, 0.3)"
          }}
        >
          {showForm ? "← Back to Sales" : "+ Add New Sale"}
        </button>
      </div>

      {showForm && (
        <div style={{ marginBottom: "2rem" }}>
          <SalesForm
            onClose={() => {
              setShowForm(false)
              setSaleToEdit(null)
            }}
            onSubmit={handleFormSubmit}
            saleToEdit={saleToEdit}
          />
        </div>
      )}

      {!showForm && (
        <div style={styles.tableContainer}>
          {loading ? (
            <div style={styles.loading}>
              <div
                style={{
                  width: "3rem",
                  height: "3rem",
                  border: "4px solid #e5e7eb",
                  borderTop: "4px solid #2563eb",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                  margin: "0 auto 1rem",
                }}
              ></div>
              <p>⏳ Loading sales...</p>
            </div>
          ) : error ? (
            <div style={styles.errorMessage}>
              <span>❌</span>
              {error}
            </div>
          ) : salesData.length > 0 ? (
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.tableHeader}>BILL NO</th>
                  <th style={styles.tableHeader}>DATE</th>
                  <th style={styles.tableHeader}>TERMS</th>
                  <th style={styles.tableHeader}>SALES MAN</th>
                  <th style={styles.tableHeader}>CUSTOMER</th>
                  <th style={styles.tableHeader}>PHONE</th>
                  <th style={styles.tableHeader}>GROSS AMT</th>
                  <th style={styles.tableHeader}>DISCOUNT</th>
                  <th style={styles.tableHeader}>BILL DISCOUNT</th>
                  <th style={styles.tableHeader}>TOTAL TAX</th>
                  <th style={styles.tableHeader}>NET AMOUNT</th>
                  <th style={styles.tableHeader}>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {salesData.map((sale, index) => (
                  <tr
                    key={sale.id}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#f7fafc" : "white",
                      transition: "background-color 0.2s ease",
                    }}
                  >
                    <td style={styles.tableCell}>{sale.billNo}</td>
                    <td style={styles.tableCell}>{sale.date}</td>
                    <td style={styles.tableCell}>{sale.terms}</td>
                    <td style={styles.salesManCell}>{sale.salesMan || currentUserName || "N/A"}</td>
                    <td style={styles.tableCell}>{sale.customer}</td>
                    <td style={styles.tableCell}>{sale.phone}</td>
                    <td style={styles.tableCell}>₹{formatNumber(sale.totals.grossAmt)}</td>
                    <td style={styles.tableCell}>₹{formatNumber(sale.totals.discount)}</td>
                    <td style={styles.tableCell}>₹{formatNumber(sale.totals.billDiscount)}</td>
                    <td style={styles.tableCell}>₹{formatNumber(sale.totals.totalTax)}</td>
                    <td style={styles.tableCell}>
                      <strong>₹{formatNumber(sale.totals.netAmount)}</strong>
                    </td>
                    <td style={styles.actionCell}>
                      <button
                        onClick={() => handleView(sale)}
                        style={styles.viewButton}
                        title="View Details"
                        onMouseEnter={(e) => {
                          e.target.style.transform = "translateY(-1px)"
                          e.target.style.boxShadow = "0 4px 12px rgba(37, 99, 235, 0.4)"
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "translateY(0)"
                          e.target.style.boxShadow = "0 2px 8px rgba(37, 99, 235, 0.3)"
                        }}
                      >
                        👁
                      </button>
                      <button
                        onClick={() => downloadPDF(sale)}
                        style={styles.pdfButton}
                        title="Download PDF"
                        onMouseEnter={(e) => {
                          e.target.style.transform = "translateY(-1px)"
                          e.target.style.boxShadow = "0 4px 12px rgba(220, 38, 38, 0.4)"
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "translateY(0)"
                          e.target.style.boxShadow = "0 2px 8px rgba(220, 38, 38, 0.3)"
                        }}
                      >
                        📄
                      </button>
                      <button
                        onClick={() => handleEdit(sale)}
                        style={styles.editButton}
                        title="Edit Sale"
                        onMouseEnter={(e) => {
                          e.target.style.transform = "translateY(-1px)"
                          e.target.style.boxShadow = "0 4px 12px rgba(16, 185, 129, 0.4)"
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "translateY(0)"
                          e.target.style.boxShadow = "0 2px 8px rgba(16, 185, 129, 0.3)"
                        }}
                      >
                        ✏️
                      </button>
                      <button
                        onClick={() => handleDelete(sale.id)}
                        style={styles.deleteButton}
                        title="Delete Sale"
                        onMouseEnter={(e) => {
                          e.target.style.transform = "translateY(-1px)"
                          e.target.style.boxShadow = "0 4px 12px rgba(220, 38, 38, 0.4)"
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "translateY(0)"
                          e.target.style.boxShadow = "0 2px 8px rgba(220, 38, 38, 0.3)"
                        }}
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div style={styles.noData}>
              <div style={{ fontSize: "4rem", marginBottom: "1rem", opacity: "0.5" }}>📄</div>
              <h3 style={{ color: "#4a5568", marginBottom: "0.5rem" }}>No Sales Found</h3>
              <p style={{ marginBottom: "1.5rem" }}>Get started by adding your first sale!</p>
              <button
                onClick={() => {
                  setShowForm(true)
                  setSaleToEdit(null)
                }}
                style={{
                  ...styles.addButton,
                  fontSize: "1rem",
                  padding: "1rem 2rem",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px)"
                  e.target.style.boxShadow = "0 6px 20px rgba(37, 99, 235, 0.4)"
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)"
                  e.target.style.boxShadow = "0 4px 15px rgba(37, 99, 235, 0.3)"
                }}
              >
                + Add Your First Sale
              </button>
            </div>
          )}
        </div>
      )}

      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @media (max-width: 768px) {
          .header { flex-direction: column; alignItems: flex-start; gap: 1rem; }
          .addButton { width: 100%; text-align: center; }
        }
        button:hover:not(:disabled) { filter: brightness(90%); }
        @media print {
          .billModal { position: static !important; background: none !important; padding: 0 !important; }
          .billContainer { width: 100% !important; max-width: none !important; max-height: none !important; overflow: visible !important; box-shadow: none !important; border-radius: 0 !important; }
          .billHeader { display: none !important; }
          .invoice { padding: 0 !important; font-size: 10px !important; }
        }
      `}</style>
    </div>
  )
}

export default SalesTable